import { z } from "zod";

/**
 * In-region variants a serverless endpoint can advertise beside its global
 * listing. A request reaches a variant through that region's pinned hosts
 * (`us.api.*`, `us-api.or.*`, ...); requests anywhere else are global.
 */
export const SERVERLESS_REGIONS = ["us", "eu"] as const;

export const ServerlessRegionSchema = z.enum(SERVERLESS_REGIONS);

export type ServerlessRegion = z.infer<typeof ServerlessRegionSchema>;
